import newsletterTypes from '../types/newsletter';

const initialStore = {
    newsletterList: [],
    isLoading: false,
};

const newsletterStore = (state = initialStore, action) => {
    switch (action.type) {
        case newsletterTypes.SET_NEWSLETTER_LIST:
            return {
                ...state,
                newsletterList: action.array,
            };
        case newsletterTypes.SET_LOADING:
            return {
                ...state,
                isLoading: action.boolean,
            };
        default:
            return state;
    }
};

export default newsletterStore;
